import { pubsub } from '@services';

/*
 * Set default animation duration
 */
window.DEFAULT_ANIMATION_DURATION = window.DEFAULT_ANIMATION_DURATION || 300;

/**
 * Prevent hash jumping
 */
document.addEventListener('click', (event) => {
  const { target } = event;

  if (target.tagName === 'A' && target.hash && target.classList.contains('prevent-hash-jump')) {
    const referencedElement = document.querySelector(target.hash);

    // If the element doesn't exist, don't do anything
    if (!referencedElement) return;
    const { scrollY } = window;

    // Prevent the default jump-to-anchor behavior
    window.scrollTo({ top: scrollY });
    setTimeout(function () {
      window.scrollTo({ top: scrollY });
    }, 1);
  }
});

/**
 * Listen for escape key and publish key:escape events
 */
document.addEventListener('keydown', ({ key }) => key === 'Escape' && pubsub.publish('key:escape'));

/*
 * Shopify Common JS
 */
if (typeof window.Shopify === 'undefined') window.Shopify = {};

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    const option = selector.options[i];
    if (value === option.value || value === option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent(`on${eventName}`, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  const method = options.method || 'post';
  const params = options.parameters || {};

  const form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (const key in params) {
    const hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (countryDomId, provinceDomId) {
  this.countryEl = document.getElementById(countryDomId);
  this.provinceEl = document.getElementById(provinceDomId);
  this.provinceContainer = this.provinceEl.closest('.form-group');
  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry() {
    const value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince() {
    const value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0)
      Shopify.setSelectorByValue(this.provinceEl, value);
  },

  countryHandler() {
    const opt = this.countryEl.options[this.countryEl.selectedIndex];
    const raw = opt.getAttribute('data-provinces');
    const provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length === 0) this.provinceContainer.style.display = 'none';
    else {
      for (let i = 0; i < provinces.length; i++) {
        const opt2 = document.createElement('option');
        opt2.value = provinces[i][0];
        opt2.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt2);
      }
      if (this.provinceContainer) this.provinceContainer.style.display = 'block';
    }
  },

  clearOptions(selector) {
    while (selector.firstChild) selector.removeChild(selector.firstChild);
  },

  setOptions(selector, values) {
    for (let i = 0; i < values.length; i++) {
      const opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};
